module.exports = __webpack_public_path__ + "img/hometop2.3b508208.png";